<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-12 rolelist">
                <div class="addrole">
                    <router-link to="/admin/dashboard/addsubcategory"><a class="">Add Subcategory</a></router-link>
                </div>
            </div>
            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Subcategory List</h5>

                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">
                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Category</th>
                                    <th>Subcategory</th>
                                    <th>image</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.subcategoryid">
                                    <td>{{data.subcategoryid}}</td>
                                    <td>{{data.categoryname}}</td>
                                    <td>{{data.subcategoryname}}</td>
                                    <td><img :src="api+'/storage/image/'+data.subcategoryimage" height="50px" width="50px"></td>
                                    <td>{{data.status}}</td>
                                    <td><button @click.prevent="deleteData(data.subcategoryid)" class="btnborderremove">
                                            <a><b-icon-trash></b-icon-trash></a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editsubcategory/' + data.subcategoryid"><button class="btnborderremove">
                                            <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listSubategory',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            api: process.env.VUE_APP_API_BASE_URL,
            tableData: [],
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/subcategory`).then((res) => {
                this.tableData = res.data;
                this.table();

            });
        },

        deleteData(subcategoryid) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/subcategory/delete/` + subcategoryid).then((res) => {
                this.list = res;
                this.getData();
                this.flashMessage.success({
                    message: 'Subcategory Deleted Successfully',
                });
            });
        },

    },

    mounted() {
        this.getData();
    },

};
</script>

<style lang="scss">
</style>
